import { getLoggedUser } from 'Selectors/user';
import { urls as itemsUrls } from 'Reducers/items';
import { urls as myadsUrls } from 'Reducers/myads';
import { decodeFilters, transformAdsFilterParams } from 'Helpers/filters';

const DEFAULT_PAGE_SIZE = 20;

export const setOpenRemoveAfterMarkAsSold = data => dispatch => {
    dispatch({
        type: 'REMOVE_MARK_AS_SOLD_MYAD',
        data
    });
};

const transformData = response => {
    return response.ok && ({ data: response.data.data.map(item => parseInt(item.id, 10)) });
};

export const recieveMyAds = (response, currentPage) => ({
    type: 'RECEIVE_MYADS',
    data: transformData(response),
    currentPage
});

export const getUserAds = ({ filter, currentPage = 1, pageSize = DEFAULT_PAGE_SIZE }) => (dispatch, getState, { get }) => {
    const user = getLoggedUser(getState());

    if (!user || !user.id) {
        return Promise.reject();
    }
    const filters = (filter && filter.length) ? decodeFilters(filter) : {};
    const cursor = (currentPage - 1) * pageSize;
    const param = cursor > 0 ? { ...filters, cursor } : filters;

    return dispatch(get(itemsUrls.getUserAds(user.id), 'ITEMS', transformAdsFilterParams(param)))
        .then(response => {
            if (response.ok) {
                dispatch(recieveMyAds(response, currentPage));
            }
            return response;
        });
};

export const disable = itemId => (dispatch, getState, { patch }) => {
    return dispatch(patch(myadsUrls.disable(itemId), 'ITEMS'));
};

export const makeFiltersRequest = userId => (dispatch, _, { get }) => {
    return dispatch(get(myadsUrls.myAdsFilters(userId), 'MYADS_FILTERS'));
};
